module.exports = __webpack_public_path__ + "img/ps.dee1e8ce.svg";